<template>
  <van-field
    v-model="val"
    :disabled="disabled"
    :label="label"
    :placeholder="placeholder || label"
    :required="required"
    :rules="[{ required: required, message: '请输入' + label }]"
    :readonly="readonly"
    :clearable="clearable"
    type="number"
    @input="change"
  />
</template>
<script>
import CONST from '@/utils/const'
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    maxlength: {
      type: Number,
      default: CONST.DECIMAL.DEFAULT_MAX_NUM
    },
    required: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      val: this.value ? parseFloat(this.value) : null
    }
  },
  watch: {
    value: function(value) {
      this.val = value
    }
  },
  methods: {
    change(value) {
      this.$emit('change', value ? parseFloat(value) : null)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/base/BaseInputNumber.vue